/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DiscussionsQueryLocal = {
    readonly storyID: string | null;
    readonly storyURL: string | null;
    readonly " $refType": "DiscussionsQueryLocal";
};
export type DiscussionsQueryLocal$data = DiscussionsQueryLocal;
export type DiscussionsQueryLocal$key = {
    readonly " $data"?: DiscussionsQueryLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"DiscussionsQueryLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DiscussionsQueryLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "storyID",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "storyURL",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '8aa082679fac428ad9ee072a0fa6344c';
export default node;
